import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, ref, computed, watchEffect } from 'vue';
import { RadioListType } from '@/types';
import BaseModal from '@/components/BaseModal.vue';
import Accordion from '@/components/AccordionRadio.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRadioModal',
  props: {
  title: {
    type: String,
    default: 'タイトル',
  },
  list: {
    type: Array as PropType<RadioListType[]>,
    default() {
      return [];
    },
  },
  modelValue: {
    type: [String, Number] as PropType<string | number | null>,
    default: '',
  },
},
  emits: ["update:modelValue", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string | number | null): void;
  (e: 'close'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const list = computed(() => props.list);



const value = ref(props.modelValue);
const modelValue = computed(() => props.modelValue);

watchEffect(() => {
  value.value = modelValue.value;
});

const close = () => {
  emit('close');
};

const clear = () => {
  value.value = '';
};

const decide = () => {
  emit('update:modelValue', value.value);
  close();
};

const rightBtnDisabled = computed(() => {
  return value.value === '' || value.value === null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    title: props.title,
    rightBtnDisabled: _unref(rightBtnDisabled),
    onClose: close,
    onLeftBtnClick: clear,
    onRightBtnClick: decide
  }, {
    default: _withCtx(() => [
      _createVNode(Accordion, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        list: _unref(list)
      }, null, 8, ["modelValue", "list"])
    ]),
    _: 1
  }, 8, ["title", "rightBtnDisabled"]))
}
}

})